<template>
  <div class="ms-count">
    <q-btn
      class="btn-quantity"
      :disable="min != null && modelValue <= min"
      flat
      icon="icon-minus"
      @click="substract"
    />
    <q-input
      :model-value="modelValue"
      class="input-count whithout-btns"
      mask="#####"
      color="white"
      type="number"
      borderless
      @update:model-value="val => $emit('update:modelValue', val)"
      @keyup="onKeyup"
    />
    <q-btn
      class="btn-quantity"
      :disable="max != null && modelValue >= max"
      flat
      icon="icon-add"
      @click="add"
    />
  </div>
</template>

<script>
/**
 *
 * MsCount Component
 *
 * @author Emmanuel Hernández <emmanuel.hernandez@marciano.com.mx>
 * @copyright 2022, Marciano Studio S.C.
 */
export default {
  name: 'MsCount',
  props: {
    modelValue: {
      type: [Number, String],
      default: '0'
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const add = () => {
      emit('update:modelValue', parseInt(props.modelValue) + 1)
    }

    const substract = () => {
      emit('update:modelValue', parseInt(props.modelValue) - 1)
    }

    const onKeyup = e => {
      e.target.value = props.modelValue
    }

    return {
      add,
      substract,
      onKeyup
    }
  }
}
</script>

<style lang="scss">
.ms-count {
  align-items: center;
  background-color: #f2f2f2;
  border-radius: 5px;
  display: flex;
  height: 40px;
  justify-content: center;
  margin-top: 5px;
  padding: 5px;
  text-align: center;
  width: 120px;

  .input-count {
    &.whithout-btns {
      .q-field__control-container {
        input[type='number']::-webkit-inner-spin-button,
        input[type='number']::-webkit-outer-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }

        input[type='number'] {
          -moz-appearance: textfield;
        }
      }
    }

    .q-field__native {
      text-align: center;
    }
  }

  .btn-quantity {
    background-color: #fff;
    border-radius: 5px;
    border: 1px solid #3b5b7333;
    box-shadow: 0px 3px 6px #0000001a;
    color: #000;
    font-size: 4px;
    height: 30px;
    width: 30px;
  }
}
</style>
